import { render, staticRenderFns } from "./Oferta.vue?vue&type=template&id=277987bf&scoped=true&"
import script from "./Oferta.vue?vue&type=script&lang=js&"
export * from "./Oferta.vue?vue&type=script&lang=js&"
import style0 from "./Oferta.vue?vue&type=style&index=0&id=277987bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277987bf",
  null
  
)

export default component.exports